/* eslint-disable react-refresh/only-export-components */
/**
 * 路由上下文
 * 参考：pro-components/src/layout/context/RouteContext.tsx
 */

import { createContext, useContext, useMemo, type ReactNode } from 'react';
import type { ProRouteObject, RouteContextType } from '../typing';

const RouteContext = createContext<RouteContextType | null>(null);

export interface RouteProviderProps {
  /** 路由配置 */
  routes?: ProRouteObject[];
  /** 子组件 */
  children: ReactNode;
}

/**
 * 路由上下文 Provider
 */
export const RouteProvider: React.FC<RouteProviderProps> = ({ children }) => {
  // 计算当前路由信息
  const contextValue = useMemo(() => {
    // TODO: 实现路由匹配逻辑
    const value: RouteContextType = {
      currentRoute: undefined,
      selectedKeys: [],
      openKeys: [],
    };

    return value;
  }, []);

  return (
    <RouteContext.Provider value={contextValue}>
      {children}
    </RouteContext.Provider>
  );
};

/**
 * 使用路由上下文
 */
export const useRouteContext = (): RouteContextType => {
  const context = useContext(RouteContext);
  if (!context) {
    throw new Error('useRouteContext must be used within RouteProvider');
  }
  return context;
};

export { RouteContext };
